import React from 'react';
import styled, { css } from 'styled-components';
import { ImageV2 } from '../ImageV2';
import { lineClampCss } from '../../helpers/lineClampCss';
import { media } from '../themes/theme';
export const CardOuter = styled.span `
  display: block;
  position: relative;
  z-index: 1;
  width: 100%;
`;
export const CardAspectRatio = styled.span `
  height: 0;
  padding-top: 142%;
  width: 100%;
  display: block;

  ${media.tablet `
    padding-top: 136%;
  `}
`;
export const CardAspectRatioInner = styled.span `
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: block;
`;
const shadow = '0.25rem';
export const CardShadow = styled.span `
  height: 100%;
  display: block;
  padding: 0 ${shadow} ${shadow} 0;
  ${media.tablet `
    padding: 0 ${shadow} ${shadow} 0;
  `}

  &::after {
    content: '';
    position: absolute;
    top: ${shadow};
    left: ${shadow};
    width: calc(100% - ${shadow});
    height: calc(100% - ${shadow});
    border-radius: 1rem;
    z-index: -1;

    ${media.tablet `
      top: ${shadow};
      left: ${shadow};
      width: calc(100% - ${shadow});
      height: calc(100% - ${shadow});
    `}
  }
`;
// Only use with icons that are not defined in CardIcons
export const CardHeaderWrapper = styled.div `
  display: inline-flex;
  align-items: center;
  width: 100%;

  svg {
    min-height: 1rem;
    min-width: 1rem;
    height: 1rem;
    width: 1rem;
    flex-shrink: 0;
    margin: 0.125rem;
  }

  ${media.tablet `

    svg {
     min-height: 1.5rem;
      min-width: 1.5rem;
      height: 1.5rem;
      width: 1.5rem;
      flex-shrink: 0;
      margin: 0.125rem;
    }
 `}
`;
export function Card({ children }) {
    return (React.createElement(CardOuter, null,
        React.createElement(CardAspectRatio, null,
            React.createElement(CardAspectRatioInner, null, children))));
}
export const CardInner = css `
  border-radius: 1rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  min-height: 100%;
  justify-content: space-between;
`;
export const CardMediaWrapper = styled.span `
  display: flex;
  justify-content: center;
  position: relative;
  align-items: center;
  flex-shrink: 1;
  height: 100%;
  color: ${props => props.theme.BrandPrimary};
  /* Looks the most pleasing visually and fills the
  remaining vertical space of the card. This spacing
  should grow or shrink depending on the size of the
  card. That's why a percentage value instead of a
  fixed rem value was chosen. */
  margin-bottom: 18%;
`;
const CardInnerImage = styled.div `
  width: 82%;
  height: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
`;
export const CardImage = ({ src, alt, className = undefined, }) => {
    return (React.createElement(CardMediaWrapper, { className: className },
        React.createElement(CardInnerImage, null,
            React.createElement(ImageV2, { src: src, alt: alt, crop: "fill", background: "white", responsive: [120, 180, 290], ratio: [1, 1] }))));
};
export const CardFooter = styled.span `
  height: 3rem;
  width: 100%;
  display: grid;
  align-content: baseline;

  ${media.tablet `
    height: 4.25rem;
  `}

  /* prevent overlapping of the card image in some breakpoints */
  z-index: +1;
`;
export const CardTitle = styled.span `
  ${lineClampCss(1)}
  font-family: ${props => props.theme.fonts.serif};
  font-size: 0.875rem;
  font-weight: bold;
  line-height: ${props => props.theme.LineHeight};
  width: 100%;
  text-align: center;
  color: ${props => props.theme.colors.darkergrey};

  ${media.tablet `
    font-size: 1rem;
  `}
`;
export const CardGrid = styled.div `
  display: grid;
  grid-gap: 1rem;
  grid-template-columns: repeat(1, 1fr);

  ${media.mobileSM `
    grid-template-columns: repeat(2, 1fr);
  `}

  @media (min-width: 34.625rem) {
    grid-gap: 1.5rem;
    grid-template-columns: repeat(3, 1fr);
  }

  ${media.laptop `
    grid-gap: 1.75rem;
    grid-template-columns: repeat(4, 1fr);
  `}
`;
/**
 * Formats seconds to hh:mm:ss
 */
export function formatAudioTime(seconds) {
    const hours = Math.floor(seconds / 3600);
    const min = Math.floor((seconds % 3600) / 60);
    const sec = Math.floor((seconds % 3600) % 60);
    return ((hours
        ? ('00' + hours).slice(String(hours).length >= 2 ? 0 : -2) + ':'
        : '') +
        ('00' + min).slice(-2) +
        ':' +
        ('00' + sec).slice(-2));
}
